export const LOGIN_ROUTE = "/login/";
export const CHAT_ROUTE = "/chat";
export const PRODUCT_ROUTE = "product/:productId";
export const ADD_PRODUCT_ROUTE = "/addProduct";
export const PROFILE_ROUTE = "/profile";
export const HOME_ROUTE = "/"; 